import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import axios from 'axios';
import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import UsernameValidatedComponent from "../../../../components/UsernameValidatedComponent";
import PasswordValidation from "../../../../components/PasswordValidation";
import { getEmailCheckingFromJVCRM } from "../../../../services/EmailChecking";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import PhoneNumberInput from "../../../../components/common/PhoneNumberInput";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import useGeneral from "../../../../components/hooks/useGeneral";
import EmailAlreadyExistCheckingWithoutTenant from "../../../../components/EmailAlreadyExistCheckingWithoutTenant";
import useTenant from "../../../../components/hooks/useTenant";
import useConfirm from "../../../../components/hooks/useConfirm";

export const UpdateUsers = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { auth }: any = useAuth();
  const { generalSetting }: any = useGeneral();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const navigate = useNavigate();
  const idNumber = useLocation();
  const [currUserName, setCurrUserName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [mobilPhoneNumber, setMobilePhoneNumber] = useState<string>("");
  const [forcePasswordChange, setForcePasswordChange] = useState<string>("Yes");
  const [enabled, setEnabled] = useState<string>("Yes");
  const [language, setLanguage] = useState<string>("English");
  const [agentCompany, setAgentCategory] = useState<string>("0");
  const [roleId, setRoleId] = useState<string>("");
  const [dateFormat, setDateFormat] = useState<string>("MM/dd/yyyy KK:mm a");
  const [roleOptions, setRoleOptions] = useState([]);
  const [usernameTouched, setUsernameTouched] = useState<boolean>(false);
  const [emailTouched, setEmailTouched] = useState<boolean>(false);
  const [isValidPassword, setIsValidPassword] = useState<boolean>(false);
  const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [disabeld, setDisabled] = useState<boolean>(true);
  const [imagePath, setImagePath] = useState<string>("");
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [uploadFileImg, setUploadFileImg] = useState<FileList>();
  const [userData, setUserData] = useState<any>(null);
  const [isUsernameChecking, setIsUsernameChecking] = useState<boolean>(false);
  const [isEmailChecking, setIsEmailChecking] = useState<boolean>(false);

  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles.length !== 0) {
      setUploadFileImg(selectedFiles);
    }
  };

  useEffect(() => {
    axios.get(`${baseURL}roles`, {
      headers: {
        'X-Tenant-ID': tenantId,
      }
    })
      .then((response) => {
        setRoleOptions(response?.data?.map((item: any) => {
          return { value: item.id, label: item.roleName }
        }));

        handleTenantError(null);
      }).catch(error => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setPleaseWaitPopup(true);
    axios
      .get(`${baseURL}users/${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setUserData(response?.data);
        setCurrUserName(response?.data?.firstName + " " + response?.data?.lastName);
        setFirstName(response?.data?.firstName);
        setLastName(response?.data?.lastName);
        setUserName(response?.data?.userName);
        setEmailAddress(response?.data?.emailAddress);
        setDateFormat(response?.data?.dateFormat);
        setMobilePhoneNumber(response?.data?.mobilPhoneNumber);
        setLanguage(response?.data?.language);
        setAgentCategory(response?.data?.agentCompany);
        setForcePasswordChange(
          response?.data?.forcePasswordChange ? "Yes" : "No"
        );
        setEnabled(response?.data?.enabled ? "Yes" : "No");
        setRoleId(response?.data?.roleId);
        setImagePath(response?.data?.imagePath);
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isUsernameChecking || isEmailChecking) return;

    setPleaseWaitPopup(true);

    let uploadedImagePath = imagePath;

    if (uploadFileImg && uploadFileImg?.length > 0) {
      const formData = new FormData();
      formData.append("ImageFile", uploadFileImg[0]);

      try {
        const uploadRes = await axios.post(`${baseURL}commonFile/Upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        });

        uploadedImagePath = uploadRes.data;
        setImagePath(uploadedImagePath);
        if (parseInt(auth?.id) === parseInt(idNumber?.state)) {
          Cookies.set("profileImg-jj-rental-ui", uploadedImagePath);
        }

        handleTenantError(null);
      } catch (err) {
        handleTenantError(err);
      }
    }

    await axios
      .put(
        `${baseURL}users?userId=${auth?.id}`,
        JSON.stringify({
          ...userData,
          firstName,
          lastName,
          userName,
          emailAddress,
          password,
          mobilPhoneNumber,
          language,
          agentCompany,
          forcePasswordChange: forcePasswordChange === "Yes" ? true : false,
          enabled: enabled === "Yes" ? true : false,
          roleId,
          dateFormat,
          imagePath: uploadedImagePath
        }),
        {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
          },
          withCredentials: true,
        }
      )
      .then(() => {
        setPleaseWaitPopup(false);
        navigate(-1)
        handleTenantError(null);
      })
      .catch((error) => {
        const errorMessage = error?.response?.data || error?.message || "File upload failed.";
        setConfirmData({
          title: 'Warning',
          summary: errorMessage,
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });
        setConfirmPopup(true);
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>User - {currUserName}</h2>
                </div>

                {
                  disabeld && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="w-full px-2">
                    <div>
                      {
                        uploadFileImg && uploadFileImg?.length > 0 && uploadFileImg?.item(0)
                          ? (
                            <img
                              className="w-[100px] h-[100px] rounded-sm"
                              alt="uploaded preview"
                              src={URL.createObjectURL(uploadFileImg?.item(0)!)}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "./images/profile-placeholder.png";
                              }}
                            />
                          ) : (
                            imagePath && (
                              <img
                                className="w-[100px] h-[100px] rounded-sm"
                                alt="profileImg"
                                src={`${baseURL}commonFile/Get?name=${imagePath}`}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = "./images/profile-placeholder.png";
                                }}
                              />
                            )
                          )
                      }

                      <div className="grid grid-cols-3 gap-6 mb-2">
                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Upload Profile Picture</label>
                          <input
                            name="profilepic"
                            type="file"
                            accept="image/*"
                            className={`block w-full rounded border ${themeStyles.form.tailwindBorderColor} px-3 py-2 shadow-sm outline-none text-sm ${themeStyles.form.tailwindLabelTextColor} placeholder:text-gray-400 focus:border-[#167AC3] ${themeStyles.form.tailwindInputTextColor} focus:ring-[#167AC3] focus:ring-offset-1 mt-1 bg-transparent`}
                            onChangeCapture={onFileChangeCapture}
                            ref={inputFileRef}
                            disabled={disabeld}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>First Name</label>
                        <input
                          type="text"
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={firstName}
                          disabled={disabeld}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Last Name</label>
                        <input
                          type="text"
                          disabled={disabeld}
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <UsernameValidatedComponent
                          userName={userName}
                          setUserName={setUserName}
                          touched={usernameTouched}
                          setTouched={setUsernameTouched}
                          setIsChecking={setIsUsernameChecking}
                          disabeld={disabeld}
                          className={{
                            label: {
                              fontSize: "12px",
                              fontWeight: 500,
                              color: themeStyles.form.labelTextColor
                            },
                            input: {
                              width: "100%",
                              fontSize: "14px",
                              borderRadius: "6px",
                              outline: "none",
                              color: themeStyles.form.inputTextColor
                            },
                            successMessage: {
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '0.25rem',
                              fontSize: '0.75rem',
                              color: '#00b300',
                            },
                            errorMessage: {
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '0.25rem',
                              fontSize: '0.75rem',
                              color: '#ff3333',
                            },

                          }}
                        />
                      </div>

                      <div>
                        <EmailAlreadyExistCheckingWithoutTenant
                          emailAddress={emailAddress}
                          setEmailAddress={setEmailAddress}
                          getEmailChecking={getEmailCheckingFromJVCRM}
                          disabeld={disabeld}
                          touched={emailTouched}
                          setTouched={setEmailTouched}
                          setIsChecking={setIsEmailChecking}
                          className={{
                            label: {
                              fontSize: "12px",
                              fontWeight: 500,
                              color: themeStyles.form.labelTextColor
                            },
                            input: {
                              width: "100%",
                              fontSize: "14px",
                              borderRadius: "6px",
                              outline: "none",
                              color: themeStyles.form.inputTextColor
                            },
                            successMessage: {
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '0.25rem',
                              fontSize: '0.75rem',
                              color: '#00b300',
                            },
                            errorMessage: {
                              display: 'flex',
                              alignItems: 'center',
                              marginTop: '0.25rem',
                              fontSize: '0.75rem',
                              color: '#ff3333',
                            },

                          }}
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      {
                        !disabeld && (
                          <div>
                            <PasswordValidation
                              password={password}
                              setPassword={setPassword}
                              isValid={isValidPassword}
                              setIsValid={setIsValidPassword}
                              touched={passwordTouched}
                              setTouched={setPasswordTouched}

                              className={{
                                label: {
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  color: themeStyles.form.labelTextColor
                                },
                                input: {
                                  width: "100%",
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  outline: "none",
                                  color: themeStyles.form.inputTextColor
                                },
                                successMessage: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '0.25rem',
                                  fontSize: '0.75rem',
                                  color: '#00b300',
                                },
                                errorMessage: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  marginTop: '0.25rem',
                                  fontSize: '0.75rem',
                                  color: '#ff3333',
                                },
                              }}
                              required={false}
                            />
                          </div>
                        )
                      }

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Language</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={language}
                          disabled={disabeld}
                          onChange={(e) => setLanguage(e.target.value)}
                        >
                          <option value="English">English</option>
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Mobile Number</label>
                        <PhoneNumberInput
                          name={"phoneNumber"}
                          value={mobilPhoneNumber}
                          setValue={setMobilePhoneNumber}
                          disabeld={disabeld}
                          fontSize={"14px"}
                          required={true}
                        />
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>RA Agent Category</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={agentCompany}
                          disabled={disabeld}
                          onChange={(e) => setAgentCategory(e.target.value)}
                        >
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value="0">{generalSetting?.companyName || "None"}</option>
                          <option className={`${themeStyles.main.tailwindSectionBg}`} value="1">Rd Rental</option>
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Date Format</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={dateFormat}
                          disabled={disabeld}
                          onChange={(e) => setDateFormat(e.target.value)}
                        >
                          <option value="MM/dd/yyyy KK:mm a">Use System Default</option>
                          <option value="yyyy-MM-dd kk:mm">2023-06-16 7:37 ()</option>
                          <option value="yyyy-MM-dd kk:mm iso">2023-06-16 7:37 (iso)</option>
                          <option value="dd-MM-yyyy kk:mm">16-06-2023 7:37 (eu)</option>
                          <option value="MM/dd/yyyy KK:mm a us">06/16/2023 7:37 AM (us)</option>
                          <option value="dd/MM/yyyy KK:mm a">16/06/2023 7:37 AM (ve)</option>
                          <option value="dd.MM.yyyy KK:mm a">16.06.2023 7:37 AM (int)</option>
                          <option value="dd-MMMM-yyyy KK:mm a">16-Jun-2023 7:37 AM (id)</option>
                          <option value="dd.MM.yyyy kk:mm">16.06.2023 7:37 (ch)</option>
                        </select>
                      </div>

                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enabled</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={enabled}
                          disabled={disabeld}
                          onChange={(e) => setEnabled(e.target.value)}
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Roles</label>
                        <select
                          className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                          value={roleId}
                          disabled={disabeld}
                          onChange={(e) => setRoleId(e.target.value)}
                        >
                          {roleOptions?.map((role: any) => (
                            <option key={role.value} value={role.value}>
                              {role.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6 my-1">
                      <div>
                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Force Password Change on Next Login</label>
                        <RadioGroup
                          row
                          value={forcePasswordChange}
                          onChange={(e) => setForcePasswordChange(e.target.value)}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={
                              <Radio
                                disabled={disabeld}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />
                            }
                            label="Yes"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                              "&.Mui-disabled .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                            }}
                          />

                          <FormControlLabel
                            value="No"
                            control={
                              <Radio
                                disabled={disabeld}
                                sx={{
                                  color: "gray",
                                  "&.Mui-checked": { color: "#167AC3" },
                                  "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                  "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                }}
                              />
                            }
                            label="No"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                              "&.Mui-disabled .MuiFormControlLabel-label": {
                                color: themeStyles.form.labelTextColor,
                              },
                            }}
                          />
                        </RadioGroup>
                      </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      {
                        !disabeld && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit"
                            disabled={isUsernameChecking || isEmailChecking}
                          >
                            {isUsernameChecking || isEmailChecking ? "Processing..." : "Save"}
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}